import { FleLayout } from "components/views/fle/FleLayout"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { IlloGlobal } from "components/views/atoms/Illustrations"
import { LeftArrowAndSpace, SpacerSwitcher, SwitchH1ToH2 } from "components/views/fle/Molecules"
import { Body } from "components/views/atoms/Bodies"
import { BottomLinkMobileOnlyStyledWrapper } from "components/views/atoms/Links"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import React from "react"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const Access = ({ onBack, onComplete }) => (
  <FleLayout>
    <LeftArrowAndSpace onBack={onBack} />
    <div className="no-pointer-events">
      <FlexRowCenter>
        <IlloGlobal />
      </FlexRowCenter>
    </div>
    <SpacerSwitcher />
    <SwitchH1ToH2>Get access to world-class care, anywhere.</SwitchH1ToH2>
    <Spacer height={0.5} />
    <Body color="black-80">
      With our global network of 2,000+ clinics and agencies, you can find the right one for your journey.
    </Body>
    <Spacer height={0.5} />
    <Body color="black-80">
      Plus, enjoy priority appointments and generous discounts at our Carrot partner providers.
    </Body>
    <Spacer height={1.5} expand />
    <FlexRowCenter>
      <BottomLinkMobileOnlyStyledWrapper>
        <ButtonPrimary onClick={onComplete}>{l`Create my account`}</ButtonPrimary>
      </BottomLinkMobileOnlyStyledWrapper>
    </FlexRowCenter>
  </FleLayout>
)
